import React, { useMemo } from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import { useStyles } from './DetailTab';

const DoctorTab = ({ data, state }) => {
  const classes = useStyles();

  const detailData = useMemo(() => {
    if (!data || data.length === 0) return [];

    const flattenedData = [];

    data.forEach((clientGroup) => {
      if (clientGroup.items && clientGroup.items.length > 0) {
        clientGroup.items.forEach((item) => {
          flattenedData.push({
            // id: item.orderNumber,
            // date: item.date,
            // client: clientGroup.client,
            doctor: clientGroup.doctor,
            quantity: item.qtyProduct || 0,
            price: item.price,
            discount: item.discount || 0,
            suma: item.suma,
            calculatedPrice: item.priceCalc,
            discountAmount: item.discountPrice,
            doctorPart: item.doctorPart
            /*hasError: (item.defect?.includes(true) ||
              item.defectNotice?.length > 0 || !item.pay),
            hasRaintake: item.raintake?.includes('reintake')*/
          });
        });
      }
    });

    const groupedData = flattenedData.reduce((acc, item) => {
      // const key = `${item.id}_${item.client}_${item.date}_${item.doctor}`;
      const key = `${item.doctor}`;

      if (acc[key]) {
        acc[key].quantity += item.quantity;
        acc[key].price += item.price;
        acc[key].discount += item.discount;
        acc[key].suma += item.suma;
        acc[key].calculatedPrice += item.calculatedPrice;
        acc[key].discountAmount += item.discountAmount;
        acc[key].doctorPart += item.doctorPart;
        // acc[key].hasError = acc[key].hasError || item.hasError;
        // acc[key].hasRaintake = acc[key].hasRaintake || item.hasRaintake;
      } else {
        acc[key] = { ...item };
      }
      return acc;
    }, {});

    return Object.values(groupedData).sort((a, b) => {
      const dateComparison = new Date(a.date) - new Date(b.date);
      if (dateComparison !== 0) return dateComparison;
      return a.id - b.id;
    });
  }, [data]);
  const getDoctorKey = (item) => item.idDoctor || item.doctor;

  const detailTotals = useMemo(() => {
    return detailData.reduce((acc, item) => {
      const doctorKey = getDoctorKey(item);

    const currentDoctorPart = data[doctorKey] !== undefined
        ? data[doctorKey]
        : item.doctorPart;

      return ({
      quantity: acc.quantity + item.quantity,
      price: acc.price + item.price,
      discount: acc.discount + item.discount,
      suma: acc.suma + item.suma,
      calculatedPrice: acc.calculatedPrice + item.calculatedPrice,
      discountAmount: acc.discountAmount + item.discountAmount,
      doctorPart: acc.doctorPart + currentDoctorPart
    })}, {
      quantity: 0,
      price: 0,
      discount: 0,
      suma: 0,
      calculatedPrice: 0,
      discountAmount: 0,
      doctorPart: 0
    });
  }, [detailData]);

  const formatNumber = (value) => {
    return new Intl.NumberFormat('uk-UA', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value || 0);
  };

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            {/*<TableCell style={{ width: '80px' }}>ID</TableCell>*/}
            {/*<TableCell style={{ width: '100px' }}>Дата</TableCell>*/}
            {/*<TableCell style={{ width: '200px' }}>Клієнт</TableCell>*/}
            <TableCell style={{ width: '200px' }}>Лікар</TableCell>
            <TableCell style={{ width: '80px' }}>Кількість</TableCell>
            <TableCell style={{ width: '100px' }}>Ціна</TableCell>
            <TableCell style={{ width: '100px' }}>Знижка</TableCell>
            <TableCell style={{ width: '100px' }}>Сума</TableCell>
            <TableCell style={{ width: '120px' }}>Ціна розрахунку</TableCell>
            <TableCell style={{ width: '120px' }}>Сума знижки</TableCell>
            {state.doctorPart && <TableCell style={{ width: '120px' }}>Сума лікаря</TableCell>}
          </TableRow>
          <TableRow className={classes.grandTotalRow}>
            <TableCell><strong>Загально:</strong></TableCell>
            {/*<TableCell></TableCell>*/}
            {/*<TableCell></TableCell>*/}
            {/*<TableCell></TableCell>*/}
            <TableCell align="center"><strong>{detailTotals.quantity}</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(detailTotals.price)}</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(detailTotals.discount)}</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(detailTotals.suma)}</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(detailTotals.calculatedPrice)}</strong></TableCell>
            <TableCell align="right"><strong>{formatNumber(detailTotals.discountAmount)}</strong></TableCell>
            {state.doctorPart && <TableCell align="right"><strong>{formatNumber(detailTotals.doctorPart)}</strong></TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {detailData.map((item, index) => (
            <TableRow
              key={`detail-doctor-${index}-${item.doctor}`}
              className={item.hasError ? classes.errorRow : item.hasRaintake
                ? classes.raintakeRow
                : classes.dataRow}
            >
              {/*<TableCell>{item.id}</TableCell>*/}
              {/*<TableCell>{formatDate(item.date)}</TableCell>*/}
              {/*<TableCell>{item.client}</TableCell>*/}
              <TableCell>{item.doctor}</TableCell>
              <TableCell align="center">{item.quantity}</TableCell>
              <TableCell align="right">{formatNumber(item.price)}</TableCell>
              <TableCell align="right">{formatNumber(item.discount)}</TableCell>
              <TableCell align="right">{formatNumber(item.suma)}</TableCell>
              <TableCell align="right">{formatNumber(item.calculatedPrice)}</TableCell>
              <TableCell align="right">{formatNumber(item.discountAmount)}</TableCell>
              {state.doctorPart && <TableCell align="right"><strong>{formatNumber(item.doctorPart)}</strong></TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DoctorTab;
